module.exports = __webpack_public_path__ + "img/logoCenterLine.65d24125.png";